import contractorService from "../../../services/ticketService/contractorService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_CONTRACTORS } from "../../../utils/constants";
import { ContractorInterface } from "../../../models/TicketModule/Contractor";

const useContractors = (page: number, pageSize: number) =>
  useQuery<ContractorInterface[], Error>({
    queryKey: [
      CACHE_KEY_CONTRACTORS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => contractorService.GetAll(page, pageSize),
  });

export default useContractors;
